import { dtoToRgObject } from '../../dto-to-rg-object.js';

const dtoToZone = (dto, versions) => {
    let data = dto.data;
    // upgrade from polygon to polygons
    if ('polygon' in dto.data && !('polygons' in dto.data)) {
        const { polygon, ...rest } = dto.data;
        data = {
            ...rest,
            polygons: [polygon]
        };
        dto = {
            ...dto,
            data
        };
    }
    return dtoToRgObject(dto, { versions, partials: {}, top: false });
};

export { dtoToZone };
//# sourceMappingURL=dto-to-zone.js.map
